import createSagaMiddleware from 'redux-saga';

// creating a saga middleware
const sagaMiddleware = createSagaMiddleware();

export default sagaMiddleware;
